module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "structure"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "epsl"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("Malachi said to me, “We’re")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("preaching FREEDOM, whether we")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("like it or not.” and i understood")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("exactly what he meant.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("—"), _c('b', [_vm._v("JOSEPH JARMAN")]), _vm._v(", "), _c('i', [_vm._v("Black Case")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23c519fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-Steinbeck-update-0005.vue
// module id = 66
// module chunks = 0